const projects = [
  // 1. RO360 CRM REACT
  {
    id: "1",
    category: "my-work",
    title: "RealOffice360™ Web App (React JS)",
    subtitle:
      "Simplified Customer Relationship Management for Real Estate Agents",
    url: "https://www.realoffice360.com",
    featured: {
      heading: "Real Estate CRM Web App",
      subheading: "RealOffice360™",
      imageUrl: "/images/ro360_crm_desktop1.jpg",
      text: `Single handedly architected and developed the frontend of RealOffice360™, a SaaS CRM for the real estate industry for a Calgary, AB based startup (React JS)`,
    },
    deliverables: [
      {
        label: "Overview",
        url: "https://app.realoffice360.com",
        synopsis: `After a prior successful collaboration, I was re-contracted to architect 
        and develop the new frontend of a real-estate CRM in React JS. Leveraging my industry 
        experience and active role in product development, I significantly improved the user 
        experience and engagement. Working closely with the product owner, designer, and backend 
        engineer, we launched a competitive SaaS CRM serving over 20,000 users. After advancing 
        into the fullstack developer role I indepentently implemented the complex email sync and
        bulk email features for the CRM.`,
        attributes: [
          {
            heading: "attributes",
            contents: [
              "Sole Frontend Engineer",
              "Frontend Development",
              "Backend Development",
              "Third-party Integrations",
              "UX/UI Design",
              "Agile/Scrum",
            ],
          },
          {
            heading: "tools",
            contents: ["VS Code", "Git", "GitLab", "Jira", "Sentry"],
          },
          {
            heading: "dev stack",
            contents: [
              "ReactJS",
              "Redux",
              "Redux Toolkit",
              "Redux Saga",
              "Material UI",
              "Webpack",
              "NodeJS",
              "ExpressJS",
              "MongoDB",
              "AWS",
            ],
          },
        ],
        media: {
          type: "TABS",
          entries: [
            {
              label: "desktop",
              url: "/images/ro360_crm_desktop1.jpg",
              title: "Click to visit website",
              pageUrl: "http://app.realoffice360.com",
            },
            {
              label: "mobile",
              url: "/images/ro360_crm_mobile1.jpg",
              title: "Click to visit website",
              pageUrl: "http://app.realoffice360.com",
            },
          ],
        },
      },
      {
        label: "Features",
        url: null,
        synopsis: `As a fullstack developer, I implemented the Email Sync feature that allows users to
        connect their Gmail and Outlook accounts to the CRM to manage and track email conversations with their
        customers in one place. In my previous role as sole frontend developer, I was delegated with 
        building the entire frontend from scratch. This comprised of building numerous custom, reusable components 
        leveraging the Material UI React component library as well as developing complex features such as the 
        fully-featured Event Schedule, Team Collaboration, the Contact Profile, and Deal Pipeline among others.`,
        attributes: [
          {
            heading: "contribution",
            contents: [
              "Email Sync & Bulk Email",
              "Team Collaboration",
              "Contacts Manager",
              "Contact Profile",
              "Deal Pipeline",
              "Event Schedule",
              "Subscription Manager",
            ],
          },
          {
            heading: "web technologies",
            contents: [
              "React JS",
              "Redux",
              "Redux Toolkit",
              "Redux Saga",
              "Material UI",
              "Webpack",
            ],
          },
          {
            heading: "tools",
            contents: ["VS Code", "Git", "GitLab", "JIRA", "AWS", "Docker"],
          },
        ],
        media: {
          type: "TABS",
          entries: [
            {
              label: "Kanban",
              url: "/images/ro360_crm_feature1.jpg",
              title: "Click to view details",
              // pageUrl: "https://realoffice360.com/crm-features-opportunity-sales-tracking-for-real-estate-agents",
            },
            {
              label: "Schedule",
              url: "/images/ro360_crm_feature2.jpg",
              title: "Click to view details",
              // pageUrl: "https://realoffice360.com/crm-features-daily-planner-and-calendar-for-real-estate-agents",
            },
            {
              label: "Team",
              url: "/images/ro360_crm_feature3.jpg",
              title: "Click to view details",
              // pageUrl: "https://realoffice360.com/crm-for-real-estate-teams",
            },
          ],
        },
      },
      {
        label: "Integrations",
        url: null,
        synopsis: `Some of the third party APIs and tools I integrated with RealOffice360™
        include EmailEngine (IMAP API), Appcues (created and implemented user onboarding flows 
        and net promoter score), Reamaze and GrooveHQ (helpdesk and support), Google Maps, 
        Google Analytics (implemented a very granular user event tracking), Facebook Analytics,
        Sentry (bug reporting)`,
        attributes: [
          {
            heading: "3rd parties",
            contents: [
              "EmailEngine API",
              "Google Maps API",
              "Google Analytics API",
              "Facebook Analytics API",
              "Sentry API",
              "Appcues API",
              "Reamaze API",
              "GrooveHQ",
            ],
          },
          {
            heading: "contribution",
            contents: [
              "User Event Tracking",
              "User Engagement Tracking",
              "User Onboarding",
              "Bugs Tracking",
              "Helpdesk",
            ],
          },
          {
            heading: "web technologies",
            contents: ["Rest APIs", "React JS", "JavaScript"],
          },
          {
            heading: "tools",
            contents: ["VS Code", "Git"],
          },
        ],
        media: {
          type: "TABS",
          entries: [
            {
              label: "Onboarding 1",
              url: "/images/ro360_crm_integrations1.jpg",
              title: "Designed and Implemented User Onboarding with Appcues",
            },
            {
              label: "Onboarding 2",
              url: "/images/ro360_crm_integrations2.jpg",
              title:
                "Designed and Implemented User Onboarding Checklist with Appcues",
            },
          ],
        },
      },
    ],
  },

  // 2. DRESSFRESH done
  {
    id: "2",
    category: "my-work",
    title: "Dressfresh™ Connect App (React Native)",
    subtitle: "Mobile App For Bluetooth Smart Gym Bag",
    url: "https://www.dressfresh.com",
    featured: {
      heading: "Smart Bag Mobile App",
      subheading: "DressFresh®",
      imageUrl: "/images/dressfresh_app_aws_amplify_1.jpg",
      text: `Developed the mobile app used for controlling the smart gym bag NOVO™ through Bluetooth (React Native) for Dressfresh Ltd., a California based startup.`,
    },
    deliverables: [
      {
        label: "mobile app",
        url: "https://dressfresh.com/about-2/",
        synopsis: `The client's (Dressfresh Ltd.) end product
        is a smart duffel bag which uses a patented ionization technology to sanitize and refresh
        worn sports gear without the use of water or chemicals. The bag is controlled with a mobile
        app through Bluetooth® technology. Shortly after I embarked on the project as mobile app developer,
        the client committed to upgrading their hardware Bluetooth® chip to v5. This required the prototype app
        to be migrated to an up-to-date version of React Native, which I gladly took on and completed.
        Soon after, I was delegated to fully rebuild the app from scratch for production release.
        Through close collaboration with the product owner and the firmware engineer, I delivered a
        robust, yet intuitive and easy-to-use mobile app for both Android and iOS written in React Native.`,
        attributes: [
          {
            heading: "technologies",
            contents: [
              "React Native",
              "Bluetooth®",
              "JavaScript",
              "AWS Amplify",
            ],
          },
          {
            heading: "attributes",
            contents: [
              "Sole Developer",
              "Mobile App Development",
              "User Experience",
              "User Auth via AWS Amplify",
              "Android & iOS Deployment",
            ],
          },
          {
            heading: "tools",
            contents: ["VS Code", "Xcode", "NodeJS", "Git"],
          },
        ],
        media: {
          type: "TABS",
          entries: [
            {
              label: "mobile app demo",
              url: "https://www.youtube.com/embed/oknEsDjREcc",
              title: "Click to play video",
            },
          ],
        },
      },
      {
        label: "bluetooth® server",
        // url: "",
        synopsis: `While the client was upgrading their hardware Bluetooth® chip to v5, in order to
          continue the development of the mobile app, I recommended and implemented a local,
          virtual Bluetooth® peripheral server (on NodeJS) to expose to the mobile app an
          identical API with that of the upcoming device firmware. This approach not only allowed
          us to quickly iterate without having to wait for the upgraded hardware modules, but
          also revealed several potential issues which we tackled on both the app and firmware
          side early on in the process.`,
        attributes: [
          {
            heading: "contribution",
            contents: ["Virtual Bluetooth® Peripheral", "API development"],
          },
          {
            heading: "technologies",
            contents: ["Node JS", "JavaScript", "Bluetooth®"],
          },
          {
            heading: "tools",
            contents: ["VS Code", "NodeJS", "JavaScript", "Git"],
          },
        ],
        media: {
          type: "TABS",
          entries: [
            {
              label: "hardware",
              url: "/images/dressfresh_module.png",
              title: "Dressfresh harware unit",
              pageUrl: "https://preorder.dressfresh.com/",
            },
          ],
        },
      },
      {
        label: "AWS Amplify",
        url: "https://aws.amazon.com/amplify/",
        synopsis: `After discussing with the client (Dressfresh Ltd.) the potential use cases of
          the smart bag operation through the mobile app, we identified some issues. If a user was
          close to several smart bags (i.e. in a gym), he/she shouldn't be presented in the
          app with all the discovered bags except their own. Moreover, the user should
          only be allowed to connect to and operate the bags they own. As a result, I
          recommended and implemented a user authentication layer (which requires
            every user to create an account and authenticate in order to use the
            app) on AWS Amplify. Additionally, I implemented a registration process where the user
            is required to register and operate only the bags they own.`,
        attributes: [
          {
            heading: "contribution",
            contents: [
              "AWS Amplify Integration",
              "UX/UI For Authentication",
              "Auth Feature Development",
              "Device Registration Feature",
            ],
          },
          {
            heading: "technologies",
            contents: ["React Native", "AWS Amplify", "JavaScript"],
          },
          {
            heading: "tools",
            contents: ["VS Code", "Amplify CLI", "Git"],
          },
        ],
        media: {
          type: "CAROUSEL",
          entries: [
            {
              label: "1",
              url: "/images/dressfresh_app_aws_amplify_1.jpg",
              title: "Click to visit website",
              pageUrl: "https://preorder.dressfresh.com/",
            },
            {
              label: "2",
              url: "/images/dressfresh_app_aws_amplify_2.jpg",
              title: "Click to visit website",
              pageUrl: "https://preorder.dressfresh.com/",
            },
            {
              label: "3",
              url: "/images/dressfresh_app_aws_amplify_3.jpg",
              title: "Click to visit website",
              pageUrl: "https://preorder.dressfresh.com/",
            },
          ],
        },
      },
    ],
  },

  // 3. PHIDGETS.edu done
  {
    id: "3",
    category: "my-work",
    title: "Phidgets Education Platform",
    subtitle: "Taking STEM & Coding To The Next Level",
    url: "https://www.phidgets.com/education",
    deliverables: [
      {
        label: "education website",
        url: "https://www.phidgets.com/education",
        synopsis: `My collaboration with Phidgets Inc. started with another project, that of designing and developming
        the frontend of their fully-custom, revamped online shopping platform. Phidgets Inc.
        makes affordable, easy to use, interconnectable USB sensors and controllers that require minimal
        electronics knowledge. A few years later I was contacted with a new request: to design, develop and deploy
        a website aimed at promoting the company's products through the provision of coding education to
        high school students. My responsibilities included the UX design (e.g. user journey, navigation, rough copy),
        UI design (e.g. layout, components, styling, typography) and of course, front-end development.
        After a close collaboration with Phidget's Education Director we succeeded in delivering both an exceptional
        learning platform for students starting coding and a comprehensive teaching resource for STEM educators.`,
        attributes: [
          {
            heading: "web technologies",
            contents: ["HTML5", "CSS3", "JavaScript", "jQuery"],
          },
          {
            heading: "attributes",
            contents: [
              "Sole Developer",
              "User Experience Design",
              "User Interface Design",
              "Layout Component Templates",
              "Frontend Development",
              "Search Engine Optimization",
            ],
          },
          {
            heading: "tools",
            contents: [
              "VS Code",
              "Git",
              "GitHub",
              "Adobe XD",
              "Adobe Photoshop",
            ],
          },
        ],
        media: {
          type: "TABS",
          entries: [
            {
              label: "desktop",
              url: "/images/phidgets_education_desktop1.jpg",
              title: "Click to visit website",
              pageUrl: "http://www.phidgets.com/education",
            },
            {
              label: "mobile",
              url: "/images/phidgets_education_mobile1.jpg",
              title: "Click to visit website",
              pageUrl: "http://www.phidgets.com/education",
            },
          ],
        },
      },
      {
        label: "custom features",
        url: "https://www.phidgets.com/education",
        synopsis: `Later on, the client requested a few other features, including the user's ability
        (student and teacher) to customize their experience to their needs. As the website features
        countless coding projects with Phidgets with actual code examples, the client requested
        a feature which would allow the user to select the operating system of their computer,
        the programming language of choice, and their integrated development environment tool
        in order for the website to display only the projects and code examples relevant to them.
        This new feature lead to increased ease-of-use of the platform abd significantly improved the user engagement.`,
        attributes: [
          {
            heading: "contribution",
            contents: ["UX Design", "Layout Design", "Frontend Development"],
          },
          {
            heading: "web technologies",
            contents: ["JavaScript", "jQuery", "HTML5", "CSS3"],
          },
          {
            heading: "tools",
            contents: ["VS Code", "Git", "Adobe XD"],
          },
        ],
        media: {
          type: "TABS",
          entries: [
            {
              label: "desktop",
              url: "/images/phidgets_education_desktop2.jpg",
              title: "Click to visit website",
              pageUrl: "https://www.phidgets.com/education/learn/projects/",
            },
          ],
        },
      },
    ],
  },

  // 4. MUSE
  {
    id: "4",
    category: "my-work",
    // featured: {
    //   heading: "Collaborative Music Game Web App",
    //   subheading: "MUSE",
    //   imageUrl: "/images/muse/muse_overview.jpg",
    //   text: "MUSE (Music Sandbox Environment) is a single-page web application I designed and developed for creation and performance of collaborative music in real time. MUSE is a co-op music platform for broad audiences that is controlled with gamepad controllers.",
    // },
    title: "MUSE: A Collaborative Music Web App",
    subtitle:
      "Facilitating Collaborative Music Making in Real Time for Everyone",
    url: null,
    deliverables: [
      {
        label: "overview",
        url: null,
        synopsis:
          "MUSE (Music Sandbox Environment) is the result of an academic research project that materialized as a single-page web application for real-time, collaborative music making. MUSE provides a group of users a local cooperative platform (i.e. couch multiplayer) for performing and creating live music using gamepad controllers. Currently, MUSE is in the proof-of-concept stage and runs in the Chrome web browser.",
        attributes: [
          {
            heading: "gamification of music",
            contents:
              "MUSE is the result of a theoretical and practical investigation of Music Gamification. Up to four players take turns in controlling the game and modifying the ongoing music output (through a time-limited turn taking game mechanic). To learn more about MUSE, please watch the gameplay video",
          },
          {
            heading: "web technologies",
            contents: [
              "WebAudio API",
              "Gamepad API",
              "JavaScript",
              "HTML5",
              "CSS3",
              "jQuery",
              "AJAX",
            ],
          },
        ],
        media: {
          type: "TABS",
          entries: [
            {
              label: "gameplay",
              url: "https://www.youtube.com/embed/vwYRiVdCYmo",
              title: "MUSE: Music Sandbox Environment Demo (4 player gameplay)",
            },
            {
              label: "tools",
              url: "/images/muse/coding_logos.png",
              title: "MUSE: Music Sandbox Environment Tools",
            },
          ],
        },
      },
      {
        label: "ux goals",
        url: null,
        synopsis:
          "My goal with MUSE was to design a collaborative, real-time music game system that achieved several key UX goals: 1. Produced a never disturbing, pleasant music output regardless of the users’ musical proficiency, 2. Appealed to broad audiences through an intuitive user interface, controls, and game rules and 3. Stimulated users’ musical curiosity and creativity in a “no-wrong-notes” environment.",
        attributes: [
          {
            heading: "ux challenge",
            contents:
              "The biggest design challenge was working within the constraints of the medium (i.e. collaborative music in real-time), where aural fatigue and gameplay downtime are inherent risks that could compromise the game flow and the overall User Experience at any time.",
          },
          // {
          //   heading: "gamification of music",
          //   contents:
          //     "MUSE is the result of a theoretical and practical investigation of Music Gamification. Up to four players take turns in controlling the game and modifying the ongoing music output (through a time-limited turn taking game mechanic). To learn more about MUSE, please watch the gameplay video"
          // }
        ],
        media: {
          type: "TABS",
          entries: [
            {
              label: "gameplay",
              url: "https://www.youtube.com/embed/vwYRiVdCYmo",
              title: "MUSE: Music Sandbox Environment Demo (4 player gameplay)",
            },
            {
              label: "tutorial",
              url: "https://www.youtube.com/embed/nOw2OKDTij0",
              title: "MUSE: Music Sandbox Environment Tutorial",
            },
          ],
        },
      },
      {
        label: "iterations",
        url: null,
        synopsis:
          "The core of my work building MUSE consisted of constant iteration through the design-prototype-test loop. With every play test, my focus was on ensuring that the new ideas and/or changes I implemented were not violating the core U.X. goals of my project. As it usually is the case, many ideas never make it to the final working prototype (see slides)",
        attributes: [
          {
            heading: "collaborative gameplay",
            contents:
              "MUSE is a couch multiplayer game, and its UI was designed following the “ten foot interaction” approach. Since all players share the same screen, just like in any other console game, they are able to see and hear the musical contributions of all the other players. This not only speeds up the learning of the game (i.e. through observation), but also facilitates group creativity by challenging the next player to creatively pick up where the previous one left off. In effect, this provides the opportunity for musical mastery at both individual and group level.",
          },
        ],
        media: {
          type: "CAROUSEL",
          entries: [
            {
              label: null,
              url: "/images/muse/sh_muse_cubes_2a.png",
              title:
                "MUSE: Musikube: UI prototype representing a musical entity in the game (failed UX testing)",
            },
            {
              label: null,
              url: "/images/muse/sh_muse_cubes_3a.png",
              title:
                "MUSE: Musikube: visual representation of a musical entity and all its current musical parameters (failed UX testing)",
            },
            {
              label: null,
              url: "/images/muse/sh_muse_grid_1a.png",
              title:
                "MUSE: UI simplified: the Speed and Range are properties of the Game Board, not of the Music Entity (passed UX testing)",
            },
            {
              label: null,
              url: "/images/muse/sh_muse_wheel_designs_1a.png",
              title:
                "MUSE: The Wheel: visual representation of a musical entity and all its current musical parameters (failed UX testing)",
            },
            {
              label: null,
              url: "/images/muse/sh_musikkube_layout_1a.png",
              title:
                "MUSE: The Game Board with Musikubes: shows the Musical Entities relative to each other on the Game Board (x-axis: Speed, y-axis: Range. Board passed UX testing)",
            },
            {
              label: null,
              url: "/images/muse/sh_musikkube_modifier_panels_a.png",
              title:
                "MUSE: Idea for the Musikube Control Interface (failed UX testing)",
            },
            {
              label: null,
              url: "/images/muse/sh_musikkube_modifier_panels_2a.png",
              title:
                "MUSE: User Flow of Player Modifying Their Own Musikube music parameters (failed UX testing)",
            },
            {
              label: null,
              url: "/images/muse/sh_game_naming_and_logo_a.png",
              title: "MUSE: a Logo is Born :)",
            },
          ],
        },
      },
      {
        label: "coding",
        url: null,
        synopsis:
          "One of the most exciting and challenging aspect of coding MUSE (apart from it being my first attempt at designing a music game and coding a web app) was the scheduling of note events. MUSE allows real-time, collaborative music creation and performance by taking a “step-sequencer” approach to its music engine. MUSE is basically made of 4 “sound makers”: a sound maker is a loop of 8 notes that is played back repeatedly. The player can change the “maker’s” sounding range (e.g. high, low) and speed (e.g. fast, slow) in real time by moving the “maker” on the game board among others.",
        attributes: [
          {
            heading: "Note Event Scheduler",
            contents:
              "The coding challenge consisted of scheduling the note events, ensuring perfect syncronicity, and allowing players to change the speed of the notes of the loop being played back in real-time. This change of speed had to occur instantly, keep in sync with all the other player's instruments, and not result in rhythmic chaos.",
          },
          {
            heading: "Audio Sampler",
            contents:
              "MUSE needs to download only a few high-quality recorded samples for its sound banks, since it applies variable playback speed at runtime to render all the “missing” pitches that were not originally sampled. This is achieved through the WebAudio API.",
          },
          {
            heading: "web technologies",
            contents: [
              "WebAudio API",
              "Gamepad API",
              "JavaScript",
              "HTML5",
              "CSS3",
              "jQuery",
              "AJAX",
            ],
          },
        ],
        media: {
          type: "TABS",
          entries: [
            {
              label: "Scheduler",
              url: "https://www.youtube.com/embed/iWPmLFMYbRM",
              title: "MUSE: Note Event Scheduler",
            },
            {
              label: "Sampler",
              url: "https://www.youtube.com/embed/F25v2VbGDCQ",
              title: "MUSE: Audio Sampler",
            },
          ],
        },
      },
    ],
  },

  // 5. HIA CRM ANGULAR
  {
    id: "5",
    category: "my-work",
    // featured: {
    //   heading: "CRM Web App",
    //   subheading: "Home Investment Advisors™",
    //   imageUrl: "/images/hia_crm_overview.jpg",
    //   text: "HIA™ CRM is a web app built by a small Calgary startup. My role as UX/UI designer and front-end developer allowed me to be part of a small but passionate team of developers and designers building a CRM for the real estate industry",
    // },
    title: "HIA™ CRM Web App (Angular JS)",
    subtitle: "Customer Relationship Management for Home Investment Advisors",
    url: "https://homeinvestmentadvisors.com/",
    deliverables: [
      {
        label: "Overview",
        url: "https://homeinvestmentadvisors.com/",
        synopsis: `A Calgary startup (Home Investment Advisors Inc.) was looking to
        grow their team to help build a customer relationship management web application
        for home investment advisors. I was offered a contract as a front-end developer
        with UX/UI skills and soon joined the small but energetic team of two other developers.
        My contribution includes considerable front-end development (Angular JS), third-party
        integration, UX/UI design, user onboarding design and implementation, initiation of and
        participation in design sprints, as well as some backend work for server-side pdf and
        charts/graphs generation.`,
        attributes: [
          {
            heading: "contribution",
            contents: [
              "Frontend Development",
              "Feature: Calendar",
              "Feature: In-app Messaging",
              "Feature: MLS Search",
              "Third-party Integrations",
              "UX/UI Design",
              "Design Sprint",
            ],
          },
          {
            heading: "tools",
            contents: ["VS Code", "Git", "Gulp", "NodeJS", "Jira", "AdobeXD"],
          },
          {
            heading: "dev stack",
            contents: [
              "AngularJS",
              "JavaScript",
              "HTML5",
              "CSS3",
              "NodeJS",
              "ExpressJS",
              "MongoDB",
            ],
          },
        ],
        media: {
          type: "TABS",
          entries: [
            {
              label: "CRM App",
              url: "https://www.youtube.com/embed/33wGM_Nm7xQ",
              title: "Overview of HIA™ CRM Web App",
            },
            {
              label: "MLS Search",
              url: "https://www.youtube.com/embed/WmVtUvna6K0",
              title: "HIA™ CRM: MLS Search",
            },
          ],
        },
      },
      {
        label: "Features",
        url: null,
        synopsis: `One of the features I co-designed and single-handedly built for
        the HIA™ CRM include the Calendar / Daily Planner, a task manager that integrates
        with the CRM clients database. Some of the characteristics of the calendar
        include: task completion, customizable task labels, activity-based task
        suggestion, daily planner, customizable daily routine among others. Another
        feature I built was the in-app messaging system (i.e. a chat web app) that allowed
        home investment advisors to communicate with their CRM database clients who were
        using the HomeHub360™ platform, and to track their conversation history in one place.`,
        attributes: [
          {
            heading: "contribution",
            contents: [
              "Calendar App",
              "Daily Planner",
              "Customizable Daily Routine",
              "Messaging App",
              "Notification System",
            ],
          },
          {
            heading: "web technologies",
            contents: [
              "AngularJS",
              "Angular Material",
              "JavaScript",
              "HTML5",
              "CSS3",
              "SocketIO",
              "ExpressJS",
              "NodeJS",
            ],
          },
          {
            heading: "tools",
            contents: ["VS Code", "Git", "Gulp", "AdobeXD"],
          },
        ],
        media: {
          type: "TABS",
          entries: [
            {
              label: "Calendar App",
              url: "https://www.youtube.com/embed/YZgX5JfmVSg",
              title: "HIA™ CRM: Calendar Feature",
            },
            {
              label: "Messaging App",
              url: "https://www.youtube.com/embed/v3-xQnng4Cs",
              title: "HIA™ CRM: Chat Feature",
            },
          ],
        },
      },
      {
        label: "Integrations",
        url: null,
        synopsis: `HIA™ CRM integrates with a number of third party APIs and tools.
        My contributions included the development of a server-side solution for generating
        PDF reports with chart / graphs pulled from the user's CRM data (NodeJS, HighCharts,
        PDFKit) to allow home investment advisors to download current real-estate market
        reports for any neighborhood in the city of Calgary. I also designed, built, and
        integrated the User Onboarding flows and Net Promoter Score with Appcues, integrated
        with HereMaps API and with the helpdesk third-party Reamaze.`,
        attributes: [
          {
            heading: "3rd parties",
            contents: [
              "HighCharts JS",
              "Appcues API",
              "HereMaps API",
              "Reamaze API",
            ],
          },
          {
            heading: "contribution",
            contents: [
              "Charts Generation",
              "PDF Generation",
              "User Onboarding",
              "Helpdesk Integration",
            ],
          },
          {
            heading: "web technologies",
            contents: ["JavaScript", "Rest APIs", "NodeJS", "SVG", "PDFKit"],
          },
          {
            heading: "tools",
            contents: ["VS Code", "Git", "Gulp"],
          },
        ],
        media: {
          type: "TABS",
          entries: [
            {
              label: "Highcharts",
              url: "/images/hia_highcharts.jpg",
              title:
                "Server-side generated Real Estate Market Report - PDF, Charts, Graphs",
            },
            {
              label: "Appcues",
              url: "/images/hia_appcues.jpg",
              title: "User Onboarding Flows, Checklists, Net Promoter Score",
            },
          ],
        },
      },
      {
        label: "Design Sprint",
        url: null,
        synopsis: `In an effort to rethink the value proposition, the target customer
        and therefore the HIA™ CRM app, I initiated running a design sprint with
        the entire team, to help establish a unified vision of the app for all the
        team members and to quickly build something that was testable with real users
        to expedite learning. My contribution includes initiating the design sprint,
        designing the interactive prototype for the sprint testing, and building an
        interactive mobile app prototype (AdobeXD) to test with our users.`,
        attributes: [
          {
            heading: "attributes",
            contents: [
              "User Journey Mapping",
              "Ideation and Sketching",
              "Interactive Prototyping",
              "User Testing",
            ],
          },
        ],
        media: {
          type: "TABS",
          entries: [
            {
              label: "SPRINT BUY-IN",
              url: "https://www.youtube.com/embed/Gx1ZiiW3TRU",
              title: "HIA™ CRM: Design Sprint Buy-in Presentation",
            },
          ],
        },
      },
      {
        label: "Prototyping",
        url: null,
        synopsis: `Three days of team effort in mapping the problem, exploring and
        sketching ideas, and deciding on what to test at the end of the design sprint
        resulted in the building of an interactive prototype that we tested with actual
        target customers in order to validate our assumptions (that we so dearly attached
        to during the sprint). The test validated some assumptions, completely invalidated
        others, but also shed light on how and what our users thought about themselves and
        the product which presented us with several growth opportunities that we never
        considered before.`,
        attributes: [
          {
            heading: "attributes",
            contents: ["Interactive Prototype", "Mobile App Prototype"],
          },
          {
            heading: "tools",
            contents: [
              "Adobe Illustrator",
              "AdobeXD",
              "Marvel App",
              "Adobe Photoshop",
              "PowerPoint",
            ],
          },
        ],
        media: {
          type: "CAROUSEL",
          entries: [
            {
              label: "",
              url: "/images/hia_prototypes_screen3.png",
              title: "Click to open interactive prototype",
              pageUrl:
                "https://xd.adobe.com/view/05ed0cef-560e-4af1-6350-b5edc0f74c32-73dc/",
            },
            {
              label: "",
              url: "/images/hia_prototypes_screen1.png",
              title: "Click to open interactive prototype",
              pageUrl:
                "https://xd.adobe.com/view/0ced9617-7c67-4bee-43d5-a18a499a340c-7adc/",
            },
            {
              label: "",
              url: "/images/hia_prototypes_screen2.png",
              title: "Click to open interactive prototype",
              pageUrl:
                "https://xd.adobe.com/view/90a446b8-01cd-45bc-5a00-ac75a3137726-e695/",
            },
            {
              label: "",
              url: "/images/hia_prototypes_screen4.png",
              title: "Click to open interactive prototype",
              pageUrl: "https://marvelapp.com/6aj8271",
            },
          ],
        },
      },
    ],
  },

  // 6. PHIDGETS.com
  {
    id: "6",
    category: "my-work",
    title: "Phidgets.com",
    subtitle: "Delivering a Superior Online Customer Experience",
    url: "https://www.phidgets.com",
    deliverables: [
      {
        label: "main website",
        url: "https://www.phidgets.com",
        synopsis:
          "Phidgets Inc. is a Calgary-based company specializing in making affordable, easy to use sensors and controllers that require minimal electronics knowledge. The client requested a solid cross-browser experience on both desktop and mobile. My responsibilities included the design of the website (layout, styling, typography) and front-end development. I collaborated with the back-end developers towards providing the user with a streamlined shopping experience across devices.",
        attributes: [
          {
            heading: "web technologies",
            contents: [
              "HTML5",
              "CSS3/SASS",
              "JavaScript",
              "jQuery",
              "Bootstrap v3",
            ],
          },
          {
            heading: "attributes",
            contents: [
              "Website Design",
              "Frontend Development",
              "Search Engine Optimization",
              "Layout Templates",
            ],
          },
          {
            heading: "tools",
            contents: [
              "Visual Studio",
              "Tortoise SVN",
              "Adobe Illustrator",
              "Adobe Photoshop",
            ],
          },
        ],
        media: {
          type: "TABS",
          entries: [
            {
              label: "desktop",
              url: "/images/phidgets_desktop1.jpg",
              title: "Click to visit website",
              pageUrl: "http://www.phidgets.com",
            },
            {
              label: "mobile",
              url: "/images/phidgets_mobile1.jpg",
              title: "Click to visit website",
              pageUrl: "http://www.phidgets.com",
            },
          ],
        },
      },
      {
        label: "wiki website",
        url: "https://www.phidgets.com/docs/Main_Page",
        synopsis:
          "Phidgets Inc. offers comprehensive API documentation for their products. I designed, styled, and implemented the support and documentation (MediaWiki) website to better support the navigational structure connecting the company's three websites and to match the documentation website with new visual identity.",
        attributes: [
          {
            heading: "web technologies",
            contents: [
              "HTML5",
              "CSS3/SASS",
              "JavaScript",
              "jQuery",
              "Bootstrap v3",
            ],
          },
          {
            heading: "attributes",
            contents: [
              "Website Design",
              "Frontend Development",
              "Navigation Architecture",
              "MediaWiki customization",
            ],
          },
          {
            heading: "tools",
            contents: [
              "Visual Studio",
              "Adobe Illustrator",
              "Adobe Photoshop",
              "Tortoise SVN",
            ],
          },
        ],
        media: {
          type: "TABS",
          entries: [
            {
              label: "desktop",
              url: "/images/phidgets_desktop2.jpg",
              title: "Click to visit website",
              pageUrl: "http://www.phidgets.com/docs/Main_Page",
            },
            {
              label: "mobile",
              url: "/images/phidgets_mobile2.jpg",
              title: "Click to visit website",
              pageUrl: "http://www.phidgets.com/docs/Main_Page",
            },
          ],
        },
      },
      {
        label: "forums website",
        url: "https://www.phidgets.com/forum/index.php",
        synopsis:
          "Phidgets Inc. offers support for their products also through their forum website. I designed, styled, and developed the website's front-end (implemented with the phpBB platform) to better support the navigational structure across the company's three websites and to match the forums website with new visual identity.",
        attributes: [
          {
            heading: "web technologies",
            contents: [
              "HTML5",
              "CSS3/SASS",
              "JavaScript",
              "jQuery",
              "Bootstrap v3",
            ],
          },
          {
            heading: "attributes",
            contents: [
              "Website Design",
              "Frontend Development",
              "Navigation Architecture",
              "phpBB Customization",
            ],
          },
          {
            heading: "tools",
            contents: [
              "Visual Studio",
              "Adobe Illustrator",
              "Adobe Photoshop",
              "Tortoise SVN",
            ],
          },
        ],
        media: {
          type: "TABS",
          entries: [
            {
              label: "desktop",
              url: "/images/phidgets_desktop3.jpg",
              title: "Click to visit website",
              pageUrl: "http://www.phidgets.com/forum/index.php",
            },
            {
              label: "mobile",
              url: "/images/phidgets_mobile3.jpg",
              title: "Click to visit website",
              pageUrl: "http://www.phidgets.com/forum/index.php",
            },
          ],
        },
      },
    ],
  },

  // 7. UWC
  {
    id: "7",
    category: "my-work",
    title: "United World Challenge Website",
    subtitle: "Promoting Solo Rowing Expedition Across the Pacific",
    url: "https://unitedworldchallenge.org",
    deliverables: [
      {
        label: "main website",
        url: "https://unitedworldchallenge.org",
        synopsis: `To pay forward his United World Colleges experience, Terrence
        Steinberg embarked on a solo row expedition across the Pacific Ocean.
        Through my close colaboration with the client I delivered a website that
        excites, informs, and promotes an amazing adventure to audiences interested in
        donating for scholarships, partnering as sponsors, and hiring Terrence
        for speaking events.`,
        attributes: [
          {
            heading: "web technologies",
            contents: ["HTML5", "CSS3/SASS", "JavaScript", "jQuery"],
          },
          {
            heading: "attributes",
            contents: [
              "Website Design",
              "Website Development",
              "Search Engine Optimization",
            ],
          },
          {
            heading: "tools",
            contents: ["VSCode", "Adobe XD"],
          },
        ],
        media: {
          type: "TABS",
          entries: [
            {
              label: "desktop",
              url: "/images/uwc_desktop1.jpg",
              title: "Click to visit website",
              pageUrl: "https://unitedworldchallenge.org",
            },
            {
              label: "mobile",
              url: "/images/uwc_mobile1.jpg",
              title: "Click to visit website",
              pageUrl: "https://unitedworldchallenge.org",
            },
          ],
        },
      },
      // {
      //   label: "wiki website",
      //   url: "https://www.phidgets.com/docs/Main_Page",
      //   synopsis:
      //     "Phidgets Inc. offers comprehensive API documentation for their products. I designed, styled, and implemented the support and documentation (MediaWiki) website to better support the navigational structure connecting the company's three websites and to match the documentation website with new visual identity.",
      //   attributes: [
      //     {
      //       heading: "web technologies",
      //       contents: [
      //         "HTML5",
      //         "CSS3/SASS",
      //         "JavaScript",
      //         "jQuery",
      //         "Bootstrap v3"
      //       ]
      //     },
      //     {
      //       heading: "attributes",
      //       contents: [
      //         "Website Design",
      //         "Frontend Development",
      //         "Navigation Architecture",
      //         "MediaWiki customization"
      //       ]
      //     },
      //     {
      //       heading: "tools",
      //       contents: [
      //         "Visual Studio",
      //         "Adobe Illustrator",
      //         "Adobe Photoshop",
      //         "Tortoise SVN"
      //       ]
      //     }
      //   ],
      //   media: {
      //     type: "TABS",
      //     entries: [
      //       {
      //         label: "desktop",
      //         url: "/images/phidgets_desktop2.jpg",
      //         title: "Click to visit website",
      //         pageUrl: "http://www.phidgets.com/docs/Main_Page"
      //       },
      //       {
      //         label: "mobile",
      //         url: "/images/phidgets_mobile2.jpg",
      //         title: "Click to visit website",
      //         pageUrl: "http://www.phidgets.com/docs/Main_Page"
      //       }
      //     ]
      //   }
      // },
      // {
      //   label: "forums website",
      //   url: "https://www.phidgets.com/forum/index.php",
      //   synopsis:
      //     "Phidgets Inc. offers support for their products also through their forum website. I designed, styled, and developed the website's front-end (implemented with the phpBB platform) to better support the navigational structure across the company's three websites and to match the forums website with new visual identity.",
      //   attributes: [
      //     {
      //       heading: "web technologies",
      //       contents: [
      //         "HTML5",
      //         "CSS3/SASS",
      //         "JavaScript",
      //         "jQuery",
      //         "Bootstrap v3"
      //       ]
      //     },
      //     {
      //       heading: "attributes",
      //       contents: [
      //         "Website Design",
      //         "Frontend Development",
      //         "Navigation Architecture",
      //         "phpBB Customization"
      //       ]
      //     },
      //     {
      //       heading: "tools",
      //       contents: [
      //         "Visual Studio",
      //         "Adobe Illustrator",
      //         "Adobe Photoshop",
      //         "Tortoise SVN"
      //       ]
      //     }
      //   ],
      //   media: {
      //     type: "TABS",
      //     entries: [
      //       {
      //         label: "desktop",
      //         url: "/images/phidgets_desktop3.jpg",
      //         title: "Click to visit website",
      //         pageUrl: "http://www.phidgets.com/forum/index.php"
      //       },
      //       {
      //         label: "mobile",
      //         url: "/images/phidgets_mobile3.jpg",
      //         title: "Click to visit website",
      //         pageUrl: "http://www.phidgets.com/forum/index.php"
      //       }
      //     ]
      //   }
      // }
    ],
  },

  // 8. MARGARET
  {
    id: "8",
    category: "my-work",
    title: "George-Hahle Academy of Music Website",
    subtitle:
      "Attracting Prospective Students through a Targeted Online Presence",
    url: "http://www.georgehahleacademy.ca",
    deliverables: [
      {
        label: "website",
        url: "http://www.georgehahleacademy.ca",
        synopsis: `George-Hahle Academy of Music provided singing lessons in Calgary,
        Alberta, with a business presence spanning over 40 years. Through a close
        collaboration with the client, I created a user-centered design that draws on
        the business’ core values and strengths with a focus on its target audience,
        using optimized SEO content in a responsive web design layout. Unfortunately, on
        June 8, 2021 the owner and teacher Margaret Ann George-Hahle passed away after
        battling cancer.`,
        attributes: [
          {
            heading: "ux & business goals",
            contents:
              "The ux and business goal was to create an online presence that not only conveyed the core values of the school but that also presented the user with a compelling and coherent journey from browsing the website to being a student of the academy.",
          },
          {
            heading: "attributes",
            contents: [
              "Website Design",
              "Frontend Development",
              "Search Engine Optimization",
            ],
          },
          {
            heading: "web technologies",
            contents: ["HTML5", "CSS3", "JavaScript", "jQuery"],
          },
          {
            heading: "tools",
            contents: ["Adobe Illustrator", "Adobe Photoshop"],
          },
        ],
        media: {
          type: "TABS",
          entries: [
            {
              label: "desktop",
              url: "/images/gham_desktop.jpg",
              title: "Click to visit website",
              pageUrl: "http://www.georgehahleacademy.ca",
            },
            {
              label: "mobile",
              url: "/images/gham_mobile.jpg",
              title: "Click to visit website",
              pageUrl: "http://www.georgehahleacademy.ca",
            },
          ],
        },
      },
      {
        label: "logotype",
        url: null,
        synopsis:
          "George-Hahle Academy of Music prides itself for providing high quality teaching and being dedicated to their students for over forty years. I created a logotype that captures the Academy’s longstanding experience through the use of a bold but subtle font face. The symmetry of the logo reflects the business’ core values of full commitment to its students by providing complete musical training.",
        attributes: [
          {
            heading: "tools",
            contents: ["Adobe Illustrator"],
          },
        ],
        media: {
          type: "TABS",
          entries: [
            {
              label: null,
              url: "/images/gham_brand.png",
              title: "George-Hahle Academy Logo",
            },
          ],
        },
      },
      {
        label: "photography",
        url: null,
        synopsis:
          "The client requested custom photography for their website with the intent of giving their visitors a glimpse into what it meant to be a student of the Academy. In taking these photographs, I aimed at capturing a genuine feel of the business, to visually support the narrative-driven design of the website to drive the conversion rate of visitors into paying customers",
        attributes: [
          {
            heading: "tools",
            contents: ["Nikon DSLR", "Adobe Photoshop"],
          },
        ],
        media: {
          type: "CAROUSEL",
          entries: [
            {
              label: null,
              url: "/images/gham_photo_collage_1a.jpg",
              title: "George-Hahle Academy Photography",
            },
            {
              label: null,
              url: "/images/gham_photo_collage_2a.jpg",
              title: "George-Hahle Academy Photography",
            },
            {
              label: null,
              url: "/images/gham_photo_collage_3a.jpg",
              title: "George-Hahle Academy Photography",
            },
          ],
        },
      },
    ],
  },

  // 9. TWWUS
  {
    id: "9",
    category: "my-work",
    title: "The World Without Us Website",
    subtitle: "Promoting the TWWUS Documentary",
    url: "http://www.theworldwithoutusdoc.com",
    deliverables: [
      {
        label: "website",
        url: "http://www.theworldwithoutusdoc.com",
        synopsis:
          "Deep Waters Ltd is an independent filmmaking company based in Anaheim, California. The World Without Us documentary investigates the U.S. military intervention around the globe. This website was designed as a single-page-application to promote the film, offer online viewing and DVD purchasing options through Pay-Pal and Amazon.",
        attributes: [
          {
            heading: "web technologies",
            contents: ["HTML5", "CSS3", "JavaScript", "jQuery"],
          },
          {
            heading: "attributes",
            contents: [
              "Website Design",
              "Frontend Development",
              "Single Page App",
              "Pay-Pal Checkout",
            ],
          },
          {
            heading: "tools",
            contents: ["Visual Studio", "Adobe Illustrator", "Adobe Photoshop"],
          },
        ],
        media: {
          type: "TABS",
          entries: [
            {
              label: "desktop",
              url: "/images/twwus_desktop.jpg",
              title: "Click to visit website",
              pageUrl: "http://www.theworldwithoutusdoc.com",
            },
            {
              label: "mobile",
              url: "/images/twwus_mobile.jpg",
              title: "Click to visit website",
              pageUrl: "http://www.theworldwithoutusdoc.com",
            },
          ],
        },
      },
      {
        label: "artwork",
        url: null,
        synopsis:
          "Marketing collateral included the design of the cover art for the DVD which is available for purchase on Amazon, and the poster for film festivals and competitions. Both the cover art and poster convey the documentary’s less conventional approach of merging archive footage with dramatic scenes.",
        attributes: [
          {
            heading: "tools",
            contents: ["Adobe Illustrator", "Adobe Illustrator"],
          },
        ],
        media: {
          type: "TABS",
          entries: [
            {
              label: "dvd cover",
              url: "/images/twwus_dvds.jpg",
              title: "TWWUS: DVD Cover Artwork",
            },
            {
              label: "poster",
              url: "/images/twwus_billboard.jpg",
              title: "TWWUS: Film Poster Artwork",
            },
          ],
        },
      },
    ],
  },

  // 10. HIA PORTAL
  {
    id: "10",
    category: "my-work",
    title: "Home Investment Advisors Web App",
    subtitle: "Certified HIA® Real Estate Agent Portal",
    url: "https://xd.adobe.com/embed/3f52ee93-e686-4b3f-7873-01eb8d56387d-4963/",
    deliverables: [
      {
        label: "agent web portal",
        url: "https://xd.adobe.com/embed/3f52ee93-e686-4b3f-7873-01eb8d56387d-4963/",
        synopsis:
          "This small project consisted in the design and development of the HIA® real-estate agent portal, with search and private web pages for agents.",
        attributes: [
          {
            heading: "tools",
            contents: [
              "Adobe Photoshop",
              "Adobe XD",
              "HTML5",
              "CSS3",
              "JavaScript",
            ],
          },
          {
            heading: "attributes",
            contents: ["UI Design", "Interactive Mockup"],
          },
        ],
        media: {
          type: "TABS",
          entries: [
            {
              label: "agent portal",
              url: "/images/hia_agent_portal.jpg",
              title: "Click to view Interactive Mockup",
              pageUrl:
                "https://xd.adobe.com/embed/3f52ee93-e686-4b3f-7873-01eb8d56387d-4963/",
            },
          ],
        },
      },
    ],
  },

  // ***** END OF MY WORK

  // ***** GRAPHIC DESIGN
  // VOEST ALPINE
  {
    id: "1",
    category: "design-work",
    title: "VoestAlpine AG",
    url: "http://www.voestalpine.com/group/en/",
    deliverables: [
      {
        label: "graphics",
        synopsis:
          "VoestAlpine AG is an international steel based technology and capital goods group based in Linz, Austria. The deliverable consisted in a presentation folder highlighting the products and services offered by the newly acquired subsidiary company Stahlhandel Ltd.",
        attributes: [
          {
            heading: "tools",
            contents: ["Adobe Illustrator", "Adobe Photoshop"],
          },
        ],
        media: {
          type: "TABS",
          entries: [
            {
              label: "cover",
              url: "/images/voest_cover_sm.jpg",
              title: "Voest Alpine Cover Artwork",
            },
            {
              label: "inner",
              url: "/images/voest_inner_sm.jpg",
              title: "Voest Alpine Cover Artwork",
            },
          ],
        },
      },
    ],
  },

  // CCIS
  {
    id: "2",
    category: "design-work",
    title: "Calgary Catholic Immigration Society",
    url: "https://www.ccisab.ca",
    deliverables: [
      {
        label: "artwork",
        synopsis:
          "Calgary Catholic Immigration Society is a non-profit organization providing settlement services to all immigrants in Southern Alberta. Bridging Immigrant Youth and Parents is a pilot program that offers a structured approach to educating immigrant families about the most important issues facing newcomer parent-child relationships. The artwork for the poster uses a stylized tree, whose trunk symbolizes the strength of a connected family, while the foliage represents mutual understanding and awareness. The branches and leaves of the tree comprise of the program’s discussion topics.",
        attributes: [
          {
            heading: "tools",
            contents: ["Adobe Illustrator", "Adobe Photoshop"],
          },
        ],
        media: {
          type: "IMG",
          entries: [
            {
              label: null,
              url: "/images/ccis_poster_sm.jpg",
              title: "Calgary Catholic Immigration Society Artwork",
            },
          ],
        },
      },
    ],
  },

  // TINET
  {
    id: "3",
    category: "design-work",
    title: "Tinet Advanced Integrated Communications",
    url: null,
    deliverables: [
      {
        label: "graphics",
        synopsis:
          "Tinet is a company specializing in telephony, phone systems, video conferencing, broadband services, and endpoints. The new logotype captures the business’ mission statement of providing advanced integrated telecommunication solutions through consulting and implementation, A/V and telepresence integration, and customized software solutions. The double-sided trifold flyer lists some of the solutions they offer.",
        attributes: [
          {
            heading: "tools",
            contents: ["Adobe Illustrator", "Adobe Photoshop", "Corel Draw"],
          },
        ],
        media: {
          type: "TABS",
          entries: [
            {
              label: "trifold",
              url: "/images/tinet_trifold_sm.jpg",
              title: "TiNet Trifold Artwork",
            },
            {
              label: "logotype",
              url: "/images/tinet_brand.png",
              title: "TiNet Logotype",
            },
          ],
        },
      },
    ],
  },

  // MICO
  {
    id: "4",
    category: "design-work",
    title: "Mico Legnami Ltd: Cora Group",
    url: "http://www.coratimber.com",
    deliverables: [
      {
        label: "graphics",
        synopsis:
          "Mico Legnami is a subsidiary of Corà Group, a large company of the Italian wood sector, specializing in wood, from raw materials to industrial processing and crafting. The presentation folder and flyer were designed for the opening of the new subsidiary in Hermanstadt. The logotype symbolizes a log passing through a wood processing machine while also extending the parent’s company brand image through the use of a similar font face.",
        attributes: [
          {
            heading: "tools",
            contents: ["Adobe Illustrator", "Adobe Photoshop", "Corel Draw"],
          },
        ],
        media: {
          type: "TABS",
          entries: [
            {
              label: "stationery",
              url: "/images/mico_all_sm.jpg",
              title: "Mico Legnami Stationery Artwork",
            },
            {
              label: "logotype",
              url: "/images/mico_brand.png",
              title: "Mico Legnami Logotype",
            },
          ],
        },
      },
    ],
  },

  // MATY
  {
    id: "5",
    category: "design-work",
    title: "Maty's Concrete Blocks Ltd.",
    url: null,
    deliverables: [
      {
        label: "graphics",
        synopsis:
          "Maty is a family-operated business specializing in concrete blocks that are energy efficient, fire-resistant, and more durable than similar products offered by the market’s leading competitors. The logotype captures the main qualities of the brand’s flagship product as a strong, reliable, efficient alternative at a competitive price point.",
        attributes: [
          {
            heading: "tools",
            contents: ["Adobe Illustrator", "Corel Draw"],
          },
        ],
        media: {
          type: "TABS",
          entries: [
            {
              label: "flyer",
              url: "/images/maty_flyers_sm.jpg",
              title: "Maty Flyer Artwork",
            },
            {
              label: "logotype",
              url: "/images/maty_brand.png",
              title: "Maty Logotype",
            },
          ],
        },
      },
    ],
  },

  // SMART
  {
    id: "6",
    category: "design-work",
    title: "Smart Loan Solutions Ltd.",
    url: null,
    deliverables: [
      {
        label: "graphics",
        synopsis:
          "Smart Loan Solutions Ltd is a young, startup company in the lending industry offering simplified, quick loan solutions to their customers. Deliverables included the company logo and a flyer highlighting the benefits of using Smart’s loans. The logotype’s combination of uppercase and lowercase letter evokes the business’ young and bold spirit, as well as the company’s innovative take on lending solutions.",
        attributes: [
          {
            heading: "tools",
            contents: ["Adobe Illustrator", "Corel Draw"],
          },
        ],
        media: {
          type: "TABS",
          entries: [
            {
              label: "flyer",
              url: "/images/smart_flyers_sm.jpg",
              title: "Smart Loan Solutions Flyer Artwork",
            },
            {
              label: "logotype",
              url: "/images/smart_brand.png",
              title: "Smart Loan Solutions Logotype",
            },
          ],
        },
      },
    ],
  },

  // ***** UX/UI *****
  // HIA
  {
    id: "1",
    category: "ux-ui-projects",
    title: "RealOffice360™ Web App",
    subtitle: "RealOffice360™ v3.0 Overhaul",
    url: "https://www.realoffice360.com",
    deliverables: [
      {
        label: "Design Sprint",
        url: null,
        synopsis:
          "In an effort to rethink the value proposition, the target customer and therefore the RealOffice360™ app, I initiated running a design sprint with the entire team, to help establish a unified vision of the app for all the team members and to quickly build something that was testable with real users to expedite learning. My contribution includes designing the interactive prototype for the sprint testing, and an interactive mobile app prototype (AdobeXD)",
        attributes: [
          {
            heading: "attributes",
            contents: [
              "User Journey Mapping",
              "Ideation and Sketching",
              "Interactive Prototyping",
              "User Testing",
            ],
          },
        ],
        media: {
          type: "TABS",
          entries: [
            {
              label: "SPRINT BUY-IN",
              url: "https://www.youtube.com/embed/Gx1ZiiW3TRU",
              title: "RealOffice360™: Design Sprint Buy-in Presentation",
            },
          ],
        },
      },
      {
        label: "Prototyping",
        url: null,
        synopsis:
          "Three days of a team effort in mapping the problem, exploring and sketching ideas, and deciding on what to test at the end of the sprint resulted in building several interactive prototypes that we tested with actual target customers in order to validate our assumptions (that we so dearly attached to durring the previous days)",
        attributes: [
          {
            heading: "attributes",
            contents: ["Interactive Prototype", "Mobile App Prototype"],
          },
          {
            heading: "tools",
            contents: [
              "Adobe Illustrator",
              "AdobeXD",
              "Marvel App",
              "Adobe Photoshop",
              "PowerPoint",
            ],
          },
        ],
        media: {
          type: "CAROUSEL",
          entries: [
            {
              label: "",
              url: "/images/hia_prototypes_screen3.png",
              title: "Click to open interactive prototype",
              pageUrl:
                "https://xd.adobe.com/view/05ed0cef-560e-4af1-6350-b5edc0f74c32-73dc/",
            },
            {
              label: "",
              url: "/images/hia_prototypes_screen1.png",
              title: "Click to open interactive prototype",
              pageUrl:
                "https://xd.adobe.com/view/0ced9617-7c67-4bee-43d5-a18a499a340c-7adc/",
            },
            {
              label: "",
              url: "/images/hia_prototypes_screen2.png",
              title: "Click to open interactive prototype",
              pageUrl:
                "https://xd.adobe.com/view/90a446b8-01cd-45bc-5a00-ac75a3137726-e695/",
            },
            {
              label: "",
              url: "/images/hia_prototypes_screen4.png",
              title: "Click to open interactive prototype",
              pageUrl: "https://marvelapp.com/6aj8271",
            },
          ],
        },
      },
    ],
  },

  // MUSE
  {
    id: "2",
    category: "ux-ui-projects",
    title: "MUSE: A Music Sandbox Environment",
    subtitle:
      "Browser-based, Collaborative Music Making and Performing in Real Time for Broad Audiences",
    url: null,
    deliverables: [
      {
        label: "overview",
        url: null,
        synopsis:
          "MUSE (a Music Sandbox Environment) is a single-page web application for real-time, collaborative music making. MUSE provides a group of users a local cooperative platform (i.e. couch multiplayer) for performing and creating live music using gamepad controllers. Currently, MUSE is at the proof-of-concept stage and runs in the Chrome web browser.",
        attributes: [
          {
            heading: "ux/ui goals",
            contents:
              "My goal with MUSE’s was to design a collaborative, real-time music game system that achieved several key UX goals: 1. Produced a never disturbing, pleasant music output regardless of the users’ musical proficiency, 2. Appealed to broad audiences through an intuitive user interface, controls, and game rules and 3. Stimulated users’ musical curiosity and creativity in a “no-wrong-notes” environment. The biggest design challenge was working within the constraints of the medium (i.e. collaborative music in real-time), where aural fatigue and gameplay downtime are inherent risks that could compromise the game flow and the overall User Experience at any time.",
          },
          {
            heading: "gamification of music",
            contents:
              "MUSE is the result of a theoretical and practical investigation of Music Gamification. Up to four players take turns in controlling the game and modifying the ongoing music output (through a time-limited turn taking game mechanic). To learn more about MUSE, please watch the gameplay video",
          },
        ],
        media: {
          type: "TABS",
          entries: [
            {
              label: "gameplay",
              url: "https://www.youtube.com/embed/vwYRiVdCYmo",
              title: "MUSE: Music Sandbox Environment Demo (4 player gameplay)",
            },
            {
              label: "tutorial",
              url: "https://www.youtube.com/embed/nOw2OKDTij0",
              title: "MUSE: Music Sandbox Environment Tutorial",
            },
          ],
        },
      },
      {
        label: "prototyping",
        url: null,
        synopsis:
          "The core of my work building MUSE consisted of constant iteration through the design-prototype-test loop. With every play test, my focus was on ensuring that the new ideas and/or changes I implemented were not violating the core U.X. goals of my project. As it usually is the case, many ideas never make it to the final working prototype (see slides)",
        attributes: [
          {
            heading: "collaborative gameplay",
            contents:
              "MUSE is a couch multiplayer game, and its UI was designed following the “ten foot interaction” approach. Since all players share the same screen, just like in any other console game, they are able to see and hear the musical contributions of all the other players. This not only speeds up the learning of the game (i.e. through observation), but also facilitates group creativity by challenging the next player to creatively pick up where the previous one left off. In effect, this provides the opportunity for musical mastery at both individual and group level.",
          },
        ],
        media: {
          type: "CAROUSEL",
          entries: [
            {
              label: null,
              url: "/images/muse/sh_muse_cubes_2a.png",
              title:
                "MUSE: Musikube: UI prototype representing a musical entity in the game (failed UX testing)",
            },
            {
              label: null,
              url: "/images/muse/sh_muse_cubes_3a.png",
              title:
                "MUSE: Musikube: visual representation of a musical entity and all its current musical parameters (failed UX testing)",
            },
            {
              label: null,
              url: "/images/muse/sh_muse_grid_1a.png",
              title:
                "MUSE: UI simplified: the Speed and Range are properties of the Game Board, not of the Music Entity (passed UX testing)",
            },
            {
              label: null,
              url: "/images/muse/sh_muse_wheel_designs_1a.png",
              title:
                "MUSE: The Wheel: visual representation of a musical entity and all its current musical parameters (failed UX testing)",
            },
            {
              label: null,
              url: "/images/muse/sh_musikkube_layout_1a.png",
              title:
                "MUSE: The Game Board with Musikubes: shows the Musical Entities relative to each other on the Game Board (x-axis: Speed, y-axis: Range. Board passed UX testing)",
            },
            {
              label: null,
              url: "/images/muse/sh_musikkube_modifier_panels_a.png",
              title:
                "MUSE: Idea for the Musikube Control Interface (failed UX testing)",
            },
            {
              label: null,
              url: "/images/muse/sh_musikkube_modifier_panels_2a.png",
              title:
                "MUSE: User Flow of Player Modifying Their Own Musikube music parameters (failed UX testing)",
            },
            {
              label: null,
              url: "/images/muse/sh_game_naming_and_logo_a.png",
              title: "MUSE: a Logo is Born :)",
            },
          ],
        },
      },
    ],
  },

  // HIA PORTAL
  // {
  //   id: "3",
  //   category: "ux-ui-projects",
  //   title: "Home Investment Advisors",
  //   subtitle: "Certified HIA® Real Estate Agent Portal",
  //   url:
  //     "https://xd.adobe.com/embed/3f52ee93-e686-4b3f-7873-01eb8d56387d-4963/",
  //   deliverables: [
  //     {
  //       label: "agent web portal",
  //       url:
  //         "https://xd.adobe.com/embed/3f52ee93-e686-4b3f-7873-01eb8d56387d-4963/",
  //       synopsis:
  //         "This small project consisted in the design and development of the HIA® real-estate agent portal, with search and private web pages for agents.",
  //       attributes: [
  //         {
  //           heading: "tools",
  //           contents: [
  //             "Adobe Photoshop",
  //             "Adobe XD",
  //             "HTML5",
  //             "CSS3",
  //             "JavaScript"
  //           ]
  //         },
  //         {
  //           heading: "attributes",
  //           contents: ["UI Design", "Interactive Mockup"]
  //         }
  //       ],
  //       media: {
  //         type: "TABS",
  //         entries: [
  //           {
  //             label: "agent portal",
  //             url: "/images/hia_agent_portal.jpg",
  //             title: "Click to view Interactive Mockup",
  //             pageUrl:
  //               "https://xd.adobe.com/embed/3f52ee93-e686-4b3f-7873-01eb8d56387d-4963/"
  //           }
  //         ]
  //       }
  //     }
  //   ]
  // },

  // // TOOLE PEET
  // {
  //   id: "4",
  //   category: "ux-ui-projects",
  //   title: "Toole Peet Insurance",
  //   url: "https://app.moqups.com/domnupopa/M2JsKWuK9K/view",
  //   deliverables: [
  //     {
  //       label: "portal app",
  //       url: "https://app.moqups.com/domnupopa/M2JsKWuK9K/view",
  //       synopsis:
  //         "I built this interactive prototype for the Calgary-based insurance company Toole Peet. They were interested in offering home owners a personal, private, and secure web portal to manage their home and auto insurance, access insurance knowledge base, and request / receive insurance advice from Toole Peet brokers.",
  //       attributes: [
  //         {
  //           heading: "tools",
  //           contents: [
  //             "Adobe Photoshop",
  //             "Moqups",
  //             "HTML5",
  //             "CSS3",
  //             "JavaScript"
  //           ]
  //         },
  //         {
  //           heading: "attributes",
  //           contents: ["UI Design", "Interactive Mockup"]
  //         }
  //       ],
  //       media: {
  //         type: "TABS",
  //         entries: [
  //           {
  //             label: "Insurance",
  //             url: "/images/hia_insurance.jpg",
  //             title: "Click to view Interactive Mockup",
  //             pageUrl: "https://app.moqups.com/domnupopa/M2JsKWuK9K/view"
  //           }
  //         ]
  //       }
  //     }
  //   ]
  // },
  // ****** END OF UX/UI

  // ****** RESEARCH *****
  {
    id: "1",
    category: "research-and-publications",
    title: "MUSE: a Music-making Sandbox Environment",
    subtitle:
      "In Proceedings to Sound and Music Computing 2015. Maynooth, Ireland.",
    url: "http://www.maynoothuniversity.ie/smc15/files/FinalProceedings.pdf",
    deliverables: [
      {
        label: "abstract",
        url: "http://www.maynoothuniversity.ie/smc15/files/FinalProceedings.pdf",
        synopsis:
          "This research project explores the intersection between computer games and music making in a collaborative, real-time context. Most music games and interfaces for live, collaborative use tend to fit one of two categories: “playful musical toys” such as console music games, apps for non-musicians and “serious musical interfaces” designed for professional use. Although most musical toys are easy to learn and sound great every time, they don’t offer any creative freedom to the player. On the other hand, serious interfaces are designed with creativity in mind, but require a significant amount of musical knowledge in order to produce a quality output in a live, collaborative environment.",
        attributes: [
          {
            heading: "The Hypothesis",
            contents:
              "This project theorized and proceeded at designing a collaborative musical environment that is easy to use by non-musicians, never produces “wrong notes”, but most importantly, it allows its users to express their musical creativity in a live environment",
          },
          {
            heading: "publication",
            contents:
              "MUSE: a Music-making Sandbox Environment for Real-Time Collaborative Play was accepted for oral presentation at the 12th Sound and Music Computing Conference in Maynooth, Ireland 2015. The research paper was published in the conference proceedings.",
          },
        ],
        media: {
          type: "TABS",
          entries: [
            {
              label: "paper",
              url: "/images/muse/smc_2015.jpg",
              title: "Click to download SMC 2015 Proceedings",
              pageUrl: "/docs/muse/IuliusPopaSMC2015.pdf",
            },
            {
              label: "presentation",
              url: "https://www.youtube.com/embed/LJP1lIRo05c",
              title: "SMC Presentation: MUSE",
            },
          ],
        },
      },
    ],
  },
  {
    id: "2",
    category: "research-and-publications",
    title: "Emotional Musification",
    subtitle: "In Proceedings of Audio Mostly 2018. ACM, New York.",
    url: "http://audiomostly.com/conference-programme-2018/",
    deliverables: [
      {
        label: "abstract",
        url: "http://audiomostly.com/conference-programme-2018/",
        synopsis:
          "“We present a method for emotional sonification that utilizes the musical game MUSE. We take advantage of the strong links between music and emotion to represent emotions as music. While we provide a prototype for measuring emotion using facial expression and physiological signals our sonification is not dependent on this. Rather we identify states within MUSE that elicit certain emotions and map those onto the arousal and valence spatial representation of emotion. In this way our efforts are compatible with emotion detection methods which can be mapped to arousal and valence. Because MUSE is based on states and state transitions we gain the ability to transition seamlessly from one state to another as new emotions are detected thus avoiding abrupt changes between music types.”",
        attributes: [
          {
            heading: "publication",
            contents:
              "Emotional Musification was accepted for oral presentation at the Audio Mostly Conference, New York, USA 2018. The paper was published in the conference proceedings.",
          },
        ],
        media: {
          type: "TABS",
          entries: [
            // {
            //   label: "proceedings",
            //   url: "/images/muse/audio_mostly_2018.jpg",
            //   title: "Click to view Conference Program",
            //   pageUrl: "http://audiomostly.com/conference-programme-2018/",
            // }
            {
              label: "paper",
              url: "/images/muse/audio_mostly_2018.jpg",
              title: "Click to download Audio Mostly 2018 Paper",
              pageUrl: "/docs/muse/AudioMostly2018Paper.pdf",
            },
            {
              label: "video",
              url: "https://www.youtube.com/embed/Xu992JSNFWM",
              title: "Emotional Musification Video Demo",
            },
          ],
        },
      },
    ],
  },
  // END OF RESEARCH
];

async function get(projectId, projectCategory) {
  // Using promise+setTimeout to mock loading
  let promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      let _categoryCount = projects.filter((e) => {
        return e.category === projectCategory;
      }).length;
      let _projects = projects.filter((e) => {
        return e.id === projectId && e.category === projectCategory;
      });

      let _currentProjectId = parseInt(projectId, 10);
      let _nextProjectId = (_currentProjectId % _categoryCount) + 1;
      let _prevProjectId =
        _currentProjectId - 1 === 0 ? _categoryCount : _currentProjectId - 1;

      resolve({
        count: _categoryCount,
        data: _projects[0],
        nextProjectId: _nextProjectId,
        prevProjectId: _prevProjectId,
      });
    }, 800);
  });

  return promise;
}

async function getFeatured() {
  // Using promise+setTimeout to mock loading
  let promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      let _featuredProjects = projects.filter((e) => {
        return e.featured;
      });
      resolve(_featuredProjects);
    });
  });

  return promise;
}

export default { get, getFeatured };



// WEBPACK FOOTER //
// ./src/mocks/MockAPI.js